module.exports = __webpack_public_path__ + "static/media/home.a0839cd6.svg";